import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulBlogArticleLink from '@entries/contentful-blog-article-link'
import ContentfulBlogTagLink from '@entries/contentful-blog-tag-link'
import ContentfulCta from '@entries/contentful-cta'
import ContentfulDeprecatedPageLink from '@entries/contentful-deprecated-page-link'
import ContentfulEmbeddedAsset from '@entries/contentful-embedded-asset'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import ContentfulGraphs from '@entries/contentful-graphs'
import ContentfulImage from '@entries/contentful-image'
import ContentfulPDFLink from '@entries/contentful-pdf-link'
import ContentfulStaticPageLink from '@entries/contentful-static-page-link'
import DefaultComponent from '@entries/default-component'
import { bold } from '@render-mark/bold'
import { code } from '@render-mark/code'
import { italic } from '@render-mark/italic'
import { sub } from '@render-mark/sub'
import { sup } from '@render-mark/sup'
import { underline } from '@render-mark/underline'
import { breakNode } from '@render-node/break'
import { deprecatedHeading2 } from '@render-node/deprecated-heading-2'
import { deprecatedHeading3 } from '@render-node/deprecated-heading3'
import { deprecatedParagraph } from '@render-node/deprecated-paragraph'
import { heading1 } from '@render-node/heading-1'
import { heading4 } from '@render-node/heading-4'
import { heading5 } from '@render-node/heading-5'
import { heading6 } from '@render-node/heading-6'
import { hr } from '@render-node/hr'
import { html } from '@render-node/html'
import { hyperlink } from '@render-node/hyperlink'
import { inlineImage } from '@render-node/inline-image'
import { linkReference } from '@render-node/link-reference'
import { listItem } from '@render-node/list-item'
import { olList } from '@render-node/ol-list'
import { quote } from '@render-node/quote'
import { table } from '@render-node/table'
import { tableCell } from '@render-node/table-cell'
import { tableHeaderCell } from '@render-node/table-header-cell'
import { tableRow } from '@render-node/table-row'
import { ulList } from '@render-node/ul-list'

import { renderText } from '../../render-text'
import { CUSTOMS, type RichTextOptions } from './types'

/**
 * @deprecated
 */
export const defaultRichTextFieldOptionsDeprecated: RichTextOptions = {
  renderMark: {
    [MARKS.UNDERLINE]: underline,
    [MARKS.ITALIC]: italic,
    [MARKS.CODE]: code,
    [MARKS.BOLD]: bold,
    [MARKS.SUPERSCRIPT]: sup,
    [MARKS.SUBSCRIPT]: sub,
  },
  renderNode: {
    [CUSTOMS.LINK_REFERENCE]: linkReference,
    [CUSTOMS.INLINE_IMAGE]: inlineImage,
    [CUSTOMS.BREAK]: breakNode,
    [CUSTOMS.HTML]: html,
    [CUSTOMS.TABLE_CELL]: tableCell,
    [BLOCKS.TABLE]: table,
    [BLOCKS.TABLE_ROW]: tableRow,
    [BLOCKS.TABLE_HEADER_CELL]: tableHeaderCell,
    [BLOCKS.TABLE_CELL]: tableCell,
    [BLOCKS.HEADING_1]: heading1,
    [BLOCKS.HEADING_2]: deprecatedHeading2,
    [BLOCKS.HEADING_3]: deprecatedHeading3,
    [BLOCKS.HEADING_4]: heading4,
    [BLOCKS.HEADING_5]: heading5,
    [BLOCKS.HEADING_6]: heading6,
    [BLOCKS.QUOTE]: quote,
    [BLOCKS.OL_LIST]: olList,
    [BLOCKS.UL_LIST]: ulList,
    [BLOCKS.LIST_ITEM]: listItem,
    [BLOCKS.HR]: hr,
    [BLOCKS.PARAGRAPH]: deprecatedParagraph,
    [INLINES.HYPERLINK]: hyperlink,
    [INLINES.ENTRY_HYPERLINK]: {
      [ContentType.ContentfulBlogArticle]: ContentfulBlogArticleLink,
      [ContentType.ContentfulDeprecatedPage]: ContentfulDeprecatedPageLink,
      [ContentType.ContentfulBlogTag]: ContentfulBlogTagLink,
      [ContentType.ContentfulStaticPage]: ContentfulStaticPageLink,
      [ContentType.ContentfulPdfLink]: ContentfulPDFLink,
      default: DefaultComponent,
    },
    [BLOCKS.EMBEDDED_ENTRY]: {
      [ContentType.ContentfulAsset]: ContentfulAsset,
      [ContentType.ContentfulCta]: ContentfulCta,
      [ContentType.ContentfulImage]: ContentfulImage,
      [ContentType.ContentfulEmbeddedAsset]: ContentfulEmbeddedAsset,
      [ContentType.ContentfulGraph]: ContentfulGraphs,
      default: DefaultComponent,
    },
    [INLINES.EMBEDDED_ENTRY]: {
      [ContentType.ContentfulAsset]: ContentfulAsset,
      [ContentType.ContentfulCta]: ContentfulCta,
      [ContentType.ContentfulImage]: ContentfulImage,
      [ContentType.ContentfulEmbeddedAsset]: ContentfulEmbeddedAsset,
      [ContentType.ContentfulGraph]: ContentfulGraphs,
      [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
      default: DefaultComponent,
    },
    [BLOCKS.EMBEDDED_ASSET]: {
      [ContentType.ContentfulAsset]: ContentfulAsset,
    },
  },
  renderText,
}
